module.exports = __webpack_public_path__ + "img/1.b849fe82.png";